// ==================== 文件大小 / 扩展名工具 ====================

const KB = 1024
const MB = KB * 1024
const GB = MB * 1024

/**
 * 格式化字节为人类可读大小
 * @param {number} bytes - 字节数
 * @returns {string} 如 "125.8 KB"、"150.0 MB"、"1.25 GB"
 */
export function formatSize(bytes) {
    if (bytes == null || isNaN(bytes)) return '-'
    if (bytes < KB) return bytes + ' B'
    if (bytes < MB) return (bytes / KB).toFixed(1) + ' KB'
    if (bytes < GB) return (bytes / MB).toFixed(1) + ' MB'
    return (bytes / GB).toFixed(2) + ' GB'
}

/**
 * 从文件名提取扩展名（不含点，小写）
 * @param {string} name - 文件名
 * @returns {string} 如 "png"、"mp4"，无扩展名返回 ""
 */
export function getExt(name) {
    if (!name) return ''
    const idx = name.lastIndexOf('.')
    return idx >= 0 ? name.slice(idx + 1).toLowerCase() : ''
}

// 文件类型枚举（与后端一致：10图片 20视频 30文件）
export const FILE_TYPE = {
    IMAGE: 10,
    VIDEO: 20,
    FILE: 30
}

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico']
const VIDEO_EXTS = ['mp4', 'm4v', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm', 'mpeg', 'mpg', '3gp']

/**
 * 根据扩展名判断文件类型枚举
 * @param {string} [ext] - 扩展名（不含点）
 * @returns {number} 10图片 20视频 30文件
 */
export function detectFileType(ext) {
    const e = (ext || '').toLowerCase()
    if (IMAGE_EXTS.includes(e)) return FILE_TYPE.IMAGE
    if (VIDEO_EXTS.includes(e)) return FILE_TYPE.VIDEO
    return FILE_TYPE.FILE
}

export function isImageExt(ext) {
    return IMAGE_EXTS.includes((ext || '').toLowerCase())
}

export function isVideoExt(ext) {
    return VIDEO_EXTS.includes((ext || '').toLowerCase())
}
